import { TESTS_ROUTES } from '../../constants/_routes'
import testsTypes from '../../constants/testsTypes'
import { axios } from '../../services'
import { current_timestamp } from '../../helpers'

// INDEX
const tests_index_request = () => {
  return {
    type: testsTypes.index.request
  }
}

const tests_index_success = (response) => {
  return {
    type: testsTypes.index.success,
    payload: response.data
  }
}

const tests_index_failure = (messages) => {
  return {
    type: testsTypes.index.failure,
    payload: messages
  }
}

const tests_index = (page=1, per_page=10, filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(tests_index_request())

    // Request
    axios.get(
      TESTS_ROUTES.index,
      {
        params: {
          page: page,
          per_page: per_page,
          sort: sort,
          order: order,
          filters: filters,
          serial: current_timestamp()
        }
      }
    ).then( response => {
      // success
      dispatch( tests_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching tests."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( tests_index_failure(errors))
    })
  }
}

export {
  tests_index,
}



// WEBPACK FOOTER //
// ./src/js/actions/tests/getindex.js